import { lazy } from "react";
import { withPageLoader } from "@tecorien/mimic";
import { links } from "links";
import { Permissions } from "permissions";
import { RouteDescription } from "types";

const ExportFilesPage = lazy(() => import("./ExportFilesPage"));

export const exportFilesRoutes: RouteDescription[] = [
  {
    path: links.exportFiles,
    element: withPageLoader(<ExportFilesPage />),
    breadcrumb: "Export",
    menuItem: {
      id: "exportFiles",
      label: "Export files",
    },
    requiredOneOfPermissions: [ Permissions.Admin, Permissions.SuperAdmin, Permissions.Compliance ],
  },
];